/** @jsx jsx */
import { jsx } from '@emotion/core';

import React from 'react';
import env from '../../env';
import { usePost } from '../../components';
import { ErrorPopup, Loading } from '../../components';
import { ProductTiles } from '../productTile--slider/productTiles--simple';
import { container } from '../siteStyle';
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb';

export function Trending(props) {
  const post = usePost();

  React.useEffect(() => {
    post.send(env.apiBase + '/api/product/getproducts', { trendingNow: true });
    // eslint-disable-next-line
  }, []);

  if (post.loading()) {
    return <Loading />
  } else if (post.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={post.errors} />
  }

  const data = post.response;
  //console.log(data.results.searchResult.items)
 
  // Create breadcrumb data for trending page
  const breadcrumbData = {
    items: [
      { title: "Home", link: "/" },
      { title: "Trending Now", link: null }
    ]
  };

  return (
    <div css={container}>
      <Breadcrumb breadcrumb={breadcrumbData} />
      <h3><strong>Trending Now</strong></h3>
      <div>
        <ProductTiles products={data.results.searchResult.items} />
      </div>
    </div>
  );
}